<ng-select
  [labelForId]="labelForId"
  class="styled-ng-select zbp-custom-select-focus-black"
  [ngClass]="[theme, customClass]"
  [class.disabled]="isDisabled"
  [class.is-invalid]="isInvalid"
  [class.zbp-custom-select-focus-blue]="focusColor === 'focusBlue'"
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [clearable]="clearable"
  [clearAllText]="clearAllText"
  [searchable]="searchable"
  [readonly]="isReadonly"
  [disabled]="isDisabled"
  [appendTo]="appendTo"
  [(ngModel)]="value"
  (ngModelChange)="onValueChange($event)"
  (blur)="onBlur()"
  (clear)="clear.emit($event)"
  [inputAttrs]="{ 'aria-describedby': ariaDescribedBy, 'aria-disabled': isDisabled.toString() }"
  [zbpNgSelectSrValue]="formControl"
  [zbpNgSelectErrorDescribedById]="errorStateLabelId">

  <!-- Custom item template for the selected label and dropdown options -->
  @if (itemTemplate) {
    <!-- Displays the selected option using the custom template via the ng-label-tmp directive from ng-select. -->
    <ng-template ng-label-tmp let-item="item">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item }"></ng-container>
    </ng-template>
    <!-- Displays the list of options using the custom template via the ng-option-tmp directive from ng-select. -->
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item, index: index }"></ng-container>
    </ng-template>
  }
</ng-select>
